import { observer } from 'mobx-react-lite';
import {
    infoOptionsActionDropdownLabel,
    infoOptionsConfirmationDialogLabel,
} from './InfoBarMessageWithOptionsAction.locstring.json';
import loc, { format } from 'owa-localize';
import * as React from 'react';
import {
    InfoBarOptionsAction,
    InfoBarOption,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import createInfoBarMessageMenuOptions from 'owa-info-bar/lib/utils/createInfoBarMessageMenuOptions';

import { confirm, DialogResponse } from 'owa-confirm-dialog';

let styles = require('./InfoBarMessageWithOptionsAction.scss');
let classNames = require('classnames/bind').bind(styles);

export interface InfoBarMessageWithOptionsActionProps extends InfoBarOptionsAction {
    className?: string;
}

export default observer(function InfoBarMessageWithOptionsAction(
    props: InfoBarMessageWithOptionsActionProps
) {
    /**
     * Callback issued when the menu item is invoked
     */
    const onItemClick = (ev?: React.MouseEvent<HTMLElement>, item?: IContextualMenuItem) => {
        if (item) {
            const { hasSelectionConfirmationDialog, onSelect } = props;
            if (hasSelectionConfirmationDialog) {
                const { selectionConfirmDialogFormatString } = props;
                const formatString: string =
                    selectionConfirmDialogFormatString || loc(infoOptionsConfirmationDialogLabel);
                const confirmationText: string = format(formatString, item.name);
                confirm('' /* title */, confirmationText /* subtext */).then(response => {
                    if (response == DialogResponse.ok) {
                        onSelect(item.data as InfoBarOption);
                    }
                });
            } else {
                onSelect(item.data as InfoBarOption);
            }
        }
    };
    /**
     * Renders the text within the command button
     */
    const onRenderText = () => {
        return (
            <div className={classNames(styles.commandButtonTextLabel, props.className)}>
                {props.actionLinkText}
            </div>
        );
    };
    const { preActionText, options } = props;
    return (
        <div className={styles.mainContainer}>
            <span className={styles.preActionText}>{preActionText}</span>
            <CommandButton
                className={styles.multipleOptionCommandButton}
                menuProps={{
                    gapSpace: 8,
                    items: createInfoBarMessageMenuOptions(options, styles.menuItemText),
                    onItemClick: onItemClick,
                }}
                onRenderMenuIcon={onRenderMenuIcon}
                /* Renders the icon within the down chevron command button */ ariaLabel={loc(
                    infoOptionsActionDropdownLabel
                )}
                onRenderText={onRenderText}
            />
        </div>
    );
});

function onRenderMenuIcon() {
    return null;
}
